import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { StockReturnRequestProvider } from '../partner/stockReturnRequestApproval/ContextAPI';
import Index from '../partner/stockReturnRequestApproval/Index';
import PermissionDenied from './PermissionDenied';

export default function StockReturnRequestPartnerApproval() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['stock-return-request-partner-approval']) return <PermissionDenied />;

    return (
        <StockReturnRequestProvider>
            <Index />
        </StockReturnRequestProvider>
    );
}
